import { displayDateFormat, storageDateFormat } from './dateFormats';
import moment from 'moment';

function createDateObject({ date = null, hasTime = true, time, timeZone = 'Europe/Oslo' } = {}, shortFormat) {
	let dateMoment = null;
	if (date === null) dateMoment = moment().tz(timeZone);
	else dateMoment = moment(date, shortFormat ? displayDateFormat : storageDateFormat).tz(timeZone);

	if (hasTime) {
		if (time) {
			let [ hours, minutes ] = time.split(':');
			dateMoment.hours(hours).minutes(minutes);
		} // else: Time is allready set to now / date.
	} else {
		dateMoment.startOf('day');
	}

	return {
		date: dateMoment.format(storageDateFormat),
		hasTime: hasTime,
		timeZone: timeZone,
		epoch: dateMoment.valueOf()
	};
}

export default createDateObject;
